module.exports = __webpack_public_path__ + "common/icon-360-163fd51ebaa91cefe7367a2d63e2af54.svg";